var _style, _path, _path2, _rect, _rect2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolbarDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#363636;}\r\n\t.st1{fill:#353535;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M21.5,7.3h-2V3.9c0-0.4-0.3-0.7-0.7-0.7h-6.2c-0.4,0-0.7,0.3-0.7,0.7v3.4h-2V3.9 c0-1.5,1.2-2.7,2.7-2.7h6.2c1.5,0,2.7,1.2,2.7,2.7V7.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "M23.3,31.7H8.1c-1.4,0-2.6-1.2-2.6-2.6V10.7h20.4v18.4C25.9,30.5,24.8,31.7,23.3,31.7z M7.5,12.7 v16.4c0,0.3,0.3,0.6,0.6,0.6h15.2c0.3,0,0.6-0.3,0.6-0.6V12.7H7.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5_",
    x: 9.9,
    y: 11.9,
    className: "st0",
    width: 2,
    height: 18.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6_",
    x: 14.8,
    y: 11.8,
    className: "st0",
    width: 2,
    height: 19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: 19.5,
    y: 11.9,
    className: "st0",
    width: 2,
    height: 18.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M27,6.4H4.5C4,6.4,3.6,6.8,3.6,7.3v0.4c0,0.5,0.4,0.9,0.9,0.9H27c0.5,0,0.9-0.4,0.9-0.9V7.3 C27.8,6.8,27.4,6.4,27,6.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolbarDelete);
export default __webpack_public_path__ + "static/media/icon-toolbar-delete.49efb7f61fee10d248317ca722f0c938.svg";
export { ForwardRef as ReactComponent };